export const REGISTER_URL = process.env.REACT_APP_REGISTER_URL ?? '#';
export const CONTACT_SALES_URL = process.env.REACT_APP_CONTACT_SALES_URL ?? '#';
